import type { IStockCategory } from "./types";

export const VIDEOS_PANEL_STOCK_MASONRY_GAPS = 8;
export const VIDEOS_PANEL_STOCK_MASONRY_COLS = 3;

export const VIDEOS_PANEL_STOCK_FAKE_CELLS = 3;

export const VIDEOS_PANEL_STOCK_QUERY_KEYS = {
  VIDEOS: "images-panel-stock-images-query",
};

export const VIDEOS_PANEL_STOCK_SKELETON_HEIGTS = [
  [67, 76, 162],
  [127, 67, 162],
  [186, 67, 162],
];

export const VIDEOS_PANEL_STOCK_CATEGORIES: IStockCategory[] = [
  {
    key: "ai_suggestions",
    label: "AI Suggestions",
    query: "",
  },
  {
    key: "business",
    query: "Business",
  },
  {
    key: "team",
    query: "Team",
  },
  {
    key: "invest",
    query: "Invest",
  },
  {
    key: "cyber",
    query: "Cyber",
  },
  {
    key: "sales",
    query: "Sales",
  },
  {
    key: "office",
    query: "Office",
  },
  {
    key: "urban",
    query: "Urban",
  },
  {
    key: "real_estate",
    query: "Real estate",
  },
  {
    key: "finance",
    query: "Finance",
  },
  {
    key: "e_commerce",
    query: "E-commerce",
  },
];
